export * as manualTaxMappings from '@wix/auto_sdk_billing_manual-tax-mappings/meta';
